import { call, put } from 'redux-saga/effects';
import api from '../../helpers/api';
import { libraryItemsLoaded, libraryItemLoadFailed, loadMoreRenderedItems } from './library-actions';

function* librarySaga() {
    try {
        const items = yield call(api.fetchData, 'libraryItems');
        yield put(libraryItemsLoaded(items));
        yield put(loadMoreRenderedItems());
    } catch (error) {
        yield put(libraryItemLoadFailed());
    }
}

export default librarySaga;
